/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Learn_Blockdetails1Inputs */

const zh_learn_blockdetails1 = /** @type {(inputs: Learn_Blockdetails1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`题块详情`)
};

const en_learn_blockdetails1 = /** @type {(inputs: Learn_Blockdetails1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Block Details`)
};

const es_learn_blockdetails1 = /** @type {(inputs: Learn_Blockdetails1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detalles de bloques`)
};

/**
* | output |
* | --- |
* | "Block Details" |
*
* @param {Learn_Blockdetails1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const learn_blockdetails1 = /** @type {((inputs?: Learn_Blockdetails1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Learn_Blockdetails1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_learn_blockdetails1(inputs)
	if (locale === "en") return en_learn_blockdetails1(inputs)
	return es_learn_blockdetails1(inputs)
});
export { learn_blockdetails1 as "learn_blockDetails" }